import { Observable, Subscription, of } from "rxjs";
import { BaseFlowComponent } from "../../../base-flow-component/base-flow-component";
import { GetLastNomenclatureBySeriesQuery } from "../../../../../../models/for-1c/get-last-nomenclature-by-series/get-last-nomenclature-by-series-1c-query";
import { Guid } from "guid-typescript";
import { Component, Input } from "@angular/core";
import { NotificationService } from "../../../../../../../core/services/notification.service";
import { NotificationType } from "../../../../../../../core/services/notification-type";
import { KeyValueObject } from "../../../../../../models/core/KeyValueObject";
import { FormGroup } from "@angular/forms";
import { InstallFlowDeviceSerialData } from "./install-flow-device-serial-data";
import { DevicesService } from "../../../../../../services/devices.service";
import { SearchDeviceData } from "../../../../../../models/device/search-device-data";
import { tap } from "rxjs/operators";

@Component({
    selector: 'install-flow-device-serial',
    templateUrl: './install-flow-device-serial.component.html',
    styleUrls: ['./install-flow-device-serial.component.scss',
        '../../../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class InstallFlowDeviceSerialComponent 
    extends BaseFlowComponent<InstallFlowDeviceSerialData> 
{
	public form: FormGroup;
    @Input() requestId: number;

    oldSerialNumber: string = null;
    serialNumberValid: boolean = true;
    partNumbers: KeyValueObject[] = [];
    nomenclatureByPartNumber: string = null;
    showLeftoverError: boolean = false;

    lookingForSerial = false;

    constructor(
        private deviceService: DevicesService,
        private notificationService: NotificationService) {
        super();
    }

    initData(): void {
        if (this.data && this.data.serialNumber) {
            this.oldSerialNumber = this.data.serialNumber;
        }
    }

    saveChanges(): Observable<any> {
        return of({});
    }

    validateInputs() {    
        if (this.data.isMultiple) {
            this.validateMultipleSerialNumbers();
        }
        else {
            this.validateSingleSerialNumber();
        }
    }

    validateSingleSerialNumber() {
        this.oldSerialNumber = this.data.serialNumber;

        this.lookingForSerial = true;
        this.deviceService.isRemainsDevices(this.requestId, this.data.serialNumber, "")
        .pipe(
            tap(() => this.lookingForSerial = false))
        .subscribe((resp: SearchDeviceData) => {
            var deviceData = resp;

            if (deviceData.isInEngineerWarehouse || deviceData.isInMainWarehouse || this.showLeftoverError) {
                this.data.nomenclature = deviceData.nomenclature;
                this.data.valid = true;
                this.data.validatedInErp = !this.showLeftoverError;
                this.goToNext();
            } else {
                this.showLeftoverError = true;
                /*this.notificationService.error({
                    title: 'Ошибка',
                    message: 'По серийному номеру не найдены остатки в 1с. Исправьте номер и попробуйте еще раз, или свяжитесь с координатором',
                    notificationType: NotificationType.Toast
                });*/
            }
        });
    }

    validateMultipleSerialNumbers() {
        let allIsValid = true;
        this.lookingForSerial = true;
        let completed = 0;
        const serialItems = this.data.serialItems;

        if (serialItems == null || serialItems.length == 0) {
            this.lookingForSerial = false;
            return;
        }

        const acceptLeftover = this.showLeftoverError;
        const finishItem = () => {
            completed++;
            if (completed != serialItems.length) {
                return;
            }

            this.lookingForSerial = false;
            if (allIsValid) {
                this.data.valid = true;
                this.goToNext();
            }
        };

        serialItems.forEach((serialItem) => {
            this.deviceService.isRemainsDevices(this.requestId, serialItem.serialNumber, "")
            .subscribe((resp: SearchDeviceData) => {
                const found = resp.isInEngineerWarehouse || resp.isInMainWarehouse;
                if (found || acceptLeftover) {
                    serialItem.nomenclature = resp.nomenclature;
                    serialItem.isSuccessful = true;
                    serialItem.validatedInErp = found;
                } else {
                    allIsValid = false;
                    serialItem.isSuccessful = false;
                    serialItem.validatedInErp = false;
                    this.showLeftoverError = true;
                }

                finishItem();
            }, () => {
                allIsValid = false;
                serialItem.isSuccessful = false;
                serialItem.validatedInErp = false;
                this.showLeftoverError = true;
                finishItem();
            });
        });
    }

    get leftoverSerialNumber(): string {
        if (this.data != null && this.data.isMultiple && this.data.serialItems != null) {
            let failedSerials = this.data.serialItems
                .filter(item => !item.isSuccessful && item.serialNumber != null && item.serialNumber.trim() != '')
                .map(item => item.serialNumber);

            if (failedSerials.length > 0) {
                return failedSerials.join(', ');
            }
        }

        return this.data != null ? this.data.serialNumber : '';
    }

    get continueDisabled() {
        if (!this.data.isMultiple) return !this.data.serialNumber;
        else return !this.data.serialItems.every(x => x.serialNumber != null && x.serialNumber.trim() != '');
    }

    changeSerialNumber(data: any) {
        if (this.showLeftoverError) {
            this.showLeftoverError = false;
        }
    }

    changeSerialItem(index: number) {
        this.changeSerialNumber(null);
        let serialItem = this.data != null && this.data.serialItems != null
            ? this.data.serialItems[index]
            : null;
        if (serialItem == null) {
            return;
        }

        serialItem.isSuccessful = false;
        serialItem.validatedInErp = false;
    }
}
